/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { object, bool, func } from 'prop-types';

// Material UI
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

// Checkout
import * as commonSelectors from '../../../../../../../../../state/ducks/Common/Common-Selectors';
import * as qasAddressSearchActions from '../../../../../../../../../state/ducks/Common/ducks/AddressSearchQAS/AddressSearchQAS-Actions';

const styles = (theme) =>  ({
    modalBox: {
        maxHeight: 'calc(100% - 96px)',
        minHeight: 'calc(100% - 96px)',
        maxWidth: 'calc(100% - 28px)',
        minWidth: 'calc(100% - 45%)',
    },
    dialogContent: {
        overflowY: 'auto',
        padding: '5px',
    },
    address: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '14px',
        fontWeight: '300',
        color: theme.palette.grey2,
        lineHeight: '18px',
    },
    header: {
        fontFamily: theme.typography.fontFamily,
        borderBottom: 'solid 1px #e6d3d3',
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: '600',
        padding: '5px',
    },
    addressInfo: {
        fontSize: '14px',
        fontWeight: '600',
    },
    orTextSplitter: {
        margin: '5px 0px',
        textAlign: 'center',
    },
    addressList: {
        fontFamily: theme.typography.fontFamily,
        padding: '5px 6px 0px',
        fontSize: '14px',
        borderBottom: 'solid 1px #d6d3d3',
    },
    buttonActionSection: {
        textAlign: 'center',
        margin: '10px 0px',
    },
    editAddressQas: {
        marginRight: '5px',
        backgroundColor: theme.palette.primaryButton,
        fontWeight: '600',
        borderRadius: 24,
        height: 48,
    },
    keepAddressQas: {
        marginRight: '5px',
        backgroundColor: theme.palette.white,
        fontWeight: '600',
        borderRadius: 24,
        height: 48,
        border: `1px solid ${theme.palette.black}`,
        '&:hover': {
            color: theme.palette.black,
            backgroundColor: theme.palette.white,
        },
    },
    shipToAddress: {
        margin: '10px 0px',
    },
    suggestionListContainer: {
        paddingBottom: '40px',
    },
    [theme.breakpoints.down('md')]: {
        editAddressQas: {
            margin: '10px auto',
        },
        keepAddressQas: {
            margin: '10px auto',
        },
    },
});

class QasAddressVerificationModal extends Component {
    getSuggestionList = (suggestionList, actionsQasAddress, handleSaveAddress) => {
        const { classes } = this.props;
        if (suggestionList && suggestionList.results && suggestionList.count > 0) {
            return suggestionList.results.map((address) => (
                <MenuItem
                    className={classes.addressList}
                    key={address.suggestion}
                    onClick={() => { actionsQasAddress.selectRecommandedAddressQasVerification(address, handleSaveAddress); }}
                >
                    {address.suggestion}
                </MenuItem>
            ));
        }
        return null;
    }

    shipToAddress = (recipient, classes) => {
        let isPoBox = false;
        let PoBoxAddressLine1 = '';
        if (recipient?.locationType?.includes('P.O.Box')) {
            isPoBox = true;
            const extraPoboxText = recipient.address1.slice(7, 13).toLowerCase();
            const defaultPoboxText = recipient.address1.slice(0, 6).toLowerCase();
            if (((/(po)(\s|box)+/g).test(extraPoboxText))) {
                PoBoxAddressLine1 = recipient.address1.replace('PO Box', '').trim();
            } else if (!(/(po)(\s|box)+/g).test(defaultPoboxText)) {
                PoBoxAddressLine1 = `PO Box ${recipient.address1}`;
            } else {
                PoBoxAddressLine1 = recipient.address1;
            }
        }

        return (
            <Grid className={classes.shipToAddress}>
                <Typography className={classes.address} align="left">
                    {isPoBox ? `${PoBoxAddressLine1}` : `${recipient.address1}`}
                </Typography>
                {recipient.address2 ? (
                    <Typography className={classes.address} align="left">
                        {`${recipient.address2}`}
                    </Typography>
                ) : null}
                <Typography className={classes.address} align="left">
                    {`${recipient.city}, ${recipient.state} ${recipient.zipCode}`}
                </Typography>
            </Grid>
        );
    };

    handleClickEdit = () => {
        const {
            actionsQasAddress, handleEditAddresBook,
        } = this.props;
        handleEditAddresBook();
        actionsQasAddress.editAddressQasVerification();
    }

    render() {
        const {
            classes,
            suggestionList,
            showAddressValidation,
            recipientForm,
            actionsQasAddress,
            handleSaveAddress,
        } = this.props;
        return (
            <Grid>
                {showAddressValidation && (
                    <Dialog
                        classes={{
                            paper: classes.modalBox,
                        }}
                        open={showAddressValidation}
                    >
                        <Typography className={classes.header}>
                            Address Verification
                        </Typography>
                        <Grid className={classes.dialogContent}>
                            <Typography className={classes.addressInfo}>
                                We could not find a match to the address:-
                            </Typography>
                            {this.shipToAddress(recipientForm, classes)}
                            <Typography className={classes.addressInfo}>
                                Please choose one of the options below to proceed
                            </Typography>
                            <Grid className={classes.buttonActionSection}>
                                <Button
                                    name="edit-address-qas"
                                    variant="contained"
                                    color="primary"
                                    data-test="checkout-recipient-address-edit"
                                    className={classes.editAddressQas}
                                    onClick={this.handleClickEdit}
                                >
                                    Edit Address
                                </Button>
                                <Button
                                    name="keep-address-qas"
                                    variant="contained"
                                    className={classes.keepAddressQas}
                                    data-test="checkout-recipient-address-keep"
                                    onClick={() => {
                                        actionsQasAddress.keepAddressQasVerification(handleSaveAddress);
                                    }}
                                >
                                    Keep Address
                                </Button>
                            </Grid>
                            {(suggestionList && suggestionList.results && suggestionList.count > 0) && (
                                <Grid>
                                    <Typography className={classes.orTextSplitter}>
                                        Or
                                    </Typography>
                                    <Typography className={classes.addressInfo} data-test="checkout-recipient-recommended-address">
                                        Select a Recommended Address:
                                    </Typography>
                                    <Grid className={classes.suggestionListContainer}>
                                        { this.getSuggestionList(suggestionList, actionsQasAddress, handleSaveAddress) }
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Dialog>
                )}
            </Grid>
        );
    }
}

QasAddressVerificationModal.propTypes = {
    classes: object.isRequired,
    suggestionList: object.isRequired,
    showAddressValidation: bool.isRequired,
    recipientForm: object.isRequired,
    actionsQasAddress: object.isRequired,
    handleSaveAddress: func,
    handleEditAddresBook: func,
};

QasAddressVerificationModal.defaultProps = {
    handleSaveAddress: () => {},
    handleEditAddresBook: () => {},
};

const mapStateToProps = (state) => ({
    suggestionList: commonSelectors.getQasSearchSuggestion(state),
    showAddressValidation: commonSelectors.getShowValidatedAddressSuggestion(state),
    recipientForm: commonSelectors.getRecipientForm(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionsQasAddress: bindActionCreators(qasAddressSearchActions, dispatch),
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(QasAddressVerificationModal);
